// import { Message, MessageBox } from 'element-ui'
chromeMsg();
function chromeMsg() {
  if (window.navigator.userAgent.indexOf('Chrome') < 0) {
    ELEMENT.MessageBox.confirm('本系统推荐使用Chrome浏览器，确定自动下载浏览器，取消忽略本提示！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then(() => {
      if (window.navigator.userAgent.indexOf('Windows NT 5') !== -1) {
        window.open('http://img.rimag.com.cn/help/download/49.0.2623.112_chrome_installer.exe')
      } else if (window.navigator.userAgent.indexOf('Mac OS') !== -1) {
        window.open('http://img.rimag.com.cn/help/download/50.0.2661.102_chrome_installer.dmg')
      } else {
        window.open('http://img.rimag.com.cn/help/download/55.0.2883.75_chrome_installer.exe')
      }
    }).catch(() => {
      ELEMENT.Message({
        type: 'success',
        message: '已取消'
      })
    })
  }
}